import { useState, useEffect } from 'react';

/**
 * Captures the browser's beforeinstallprompt event and exposes a trigger.
 * Returns { canInstall, install, dismiss }.
 * `canInstall` is true only on browsers that support PWA install (Chrome/Edge on Android/desktop).
 */
const DISMISSED_KEY = 'pwa_install_dismissed';

export function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === '1'
  );

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    if (outcome === 'accepted') {
      localStorage.setItem(DISMISSED_KEY, '1');
      setDismissed(true);
    }
  };

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setDismissed(true);
  };

  return { canInstall: !!deferredPrompt && !dismissed, install, dismiss };
}
